import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import withErrorBoundary from './with-error-boundary';
class ErrorPanel extends React.Component {
    render() {
        return _jsx("div", { children: this.props.children });
    }
}
export default withErrorBoundary(ErrorPanel);
